import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id D0DB0495-F23A-4DF1-AE7B-704259C648F1
 * name sticker-minus
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sticker-minus.svg
 * tags
 */
export const StickerMinusIcon = createSvgIcon(<><path d="M18.5 2H5.5C3.6 2 2 3.6 2 5.5V18.5C2 20.4 3.6 22 5.5 22H16L22 16V5.5C22 3.6 20.4 2 18.5 2M8 11H16V13H8V11M15 20V18.5C15 16.6 16.6 15 18.5 15H20L15 20Z" /></>, 'StickerMinusIcon');
export default StickerMinusIcon